import React from "react";
import ReactDOM from "react-dom/client";
/* React Flow base styles must load before app CSS so index.css can override (parchment, transparent background layer). */
import "reactflow/dist/style.css";
import "@/index.css";
import App from "@/App";
import { initArchivePersonalization } from "@/utils/archivePersonalization";
import "@/utils/authHttp";

initArchivePersonalization();

const isDevelopment = process.env.NODE_ENV === "development";

if (isDevelopment && "serviceWorker" in navigator) {
  // Dev-only hard reset: avoid stale bundles/pages from prior service worker caches.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });

  if ("caches" in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName);
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
